import { create } from "zustand";

export type ProgressTheme = "blue" | "green" | "emerald";

type ProgressState = {
  isActive: boolean;
  progress: number;
  label: string;
  theme: ProgressTheme;
  startProgress: (label: string, theme?: ProgressTheme) => void;
  updateProgress: (progress: number, label?: string) => void;
  stopProgress: () => void;
};

export const useProgressStore = create<ProgressState>((set) => ({
  isActive: false,
  progress: 0,
  label: "",
  theme: "blue",
  startProgress: (label, theme = "blue") =>
    set({
      isActive: true,
      progress: 0,
      label,
      theme,
    }),
  updateProgress: (progress, label) =>
    set((state) => ({
      progress: Math.min(Math.max(progress, 0), 100),
      label: label ?? state.label,
    })),
  stopProgress: () =>
    set({
      isActive: false,
      progress: 0,
      label: "",
      theme: "blue",
    }),
}));
